import React, { useState, SyntheticEvent } from 'react';

import './index.css';
import ig from '../../Assets/Imagenes/ig_icon.png';
import fb from '../../Assets/Imagenes/fb_wht.png';
import tw from '../../Assets/Imagenes/x_wht.png';
import yt from '../../Assets/Imagenes/yt_icon.png';
import newLogo from '../../Assets/Imagenes/vepet-logo-no-bg.png';
import termsConditions from '../RegisterForm/termsCondition';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Donate from '../WelcomePage/Donate';
import Interest from '../WelcomePage/Interest';
// import chat from '../../Assets/Imagenes/chat_icon.png';

function Footer() {
  const [showTermsConditions, setShowTermsConditions] = useState<boolean>(false);
  const [toggleDonate, setToggleDonate] = useState<boolean>(false);
  const [toggleInterest, setToggleInterest] = useState<boolean>(false);

  function togglePopUpDonate(event: SyntheticEvent) {
    event.preventDefault();
    setToggleDonate(!toggleDonate);
  }

  function togglePopUpInterest(event: SyntheticEvent) {
    event.preventDefault();
    setToggleInterest(!toggleInterest);
  }

  return (
    <>
      <div className="Footer">
        <img src={newLogo} className="footer-logo" alt="Mascotalerta Logo" />
        <div className="footer-buttons-container">
          <a href="https://www.instagram.com/mascotalerta/" target="_blank" rel="noopener noreferrer">
            <img src={ig} className='footer-button' alt="Instagram" />
          </a>
          <a href="https://www.facebook.com/mascotalerta.cl/" target="_blank" rel="noopener noreferrer">
            <img src={fb} className='footer-button' alt="Facebook" />
          </a>
          <a href="https://twitter.com/mascotalerta" target="_blank" rel="noopener noreferrer">
            <img src={tw} className='footer-button' alt="Twitter" />
          </a>
          <a href="https://www.youtube.com/@mascotalerta" target="_blank" rel="noopener noreferrer">
            <img src={yt} className='footer-button' alt="YouTube" />
          </a>
        </div>
        <div className="footer-terms-donate">
          <div className="FooterLegend" onClick={e => togglePopUpDonate(e)}>Dona a Mascotalerta</div>
          <div className="FooterLegend" onClick={e => togglePopUpInterest(e)}>Páginas de interés</div>
        </div>
      </div>

      {showTermsConditions && (
        <Dialog open={showTermsConditions} scroll='paper' maxWidth='lg'>
          <DialogActions>
            <button className='closeForm' onClick={() => setShowTermsConditions(false)}><CloseIcon /></button>
          </DialogActions>
          <DialogTitle id="scroll-dialog-title">
            <h4><strong>TÉRMINOS Y CONDICIONES Y AVISO DE PRIVACIDAD</strong></h4>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
              {termsConditions()}
            </DialogContentText>
          </DialogContent>
        </Dialog>
      )}

      {toggleDonate && (
        <div className='register-form-container'>
          <div className='register-form-content'>
            <Donate closePopUpVerification={togglePopUpDonate} />
          </div>
        </div>
      )}

      {toggleInterest && (
        <div className='register-form-container'>
          <div className='register-form-content'>
            <Interest closePopUpVerification={togglePopUpInterest} />
          </div>
        </div>
      )}
    </>
  );
}

export default Footer;
